import { lazy, Suspense } from 'react'
import { useLocation } from 'react-router'
import {
  BrowserView, MobileOnlyView, TabletView, isMobileOnly, isTablet
} from 'react-device-detect'
import AsyncErrorBoundary from '../components/AsyncErrorBoundary'
import LoadSpinner from '../components/loadSpinner/LoadSpinner'
import HomeMobile from './HomeMobile'

const LazyNewOverview = lazy(() => import(/* webpackChunkName: "newOverview" */ './NewOverview'))
const LazyDashboardV2 = lazy(() => import(/* webpackChunkName: "dashboardV2" */ './dashboard-v2/DashboardV2'))

export function NewOverview(props) {
  return (
    <AsyncErrorBoundary>
      <Suspense fallback={<LoadSpinner className="centered" />}>
        <LazyNewOverview {...props} />
      </Suspense>
    </AsyncErrorBoundary>
  )
}

export function DashboardV2() {
  return (
    <AsyncErrorBoundary>
      <Suspense fallback={<LoadSpinner className="centered" />}>
        <LazyDashboardV2 />
      </Suspense>
    </AsyncErrorBoundary>
  )
}

export default function Home() {
  // dashboard v2 is the start page on desktop and tablet. Phones keep the card stack with
  // what is due today as their start page; they reach the dashboard through /dashboard (menu).
  // Only on "/": Home also renders /tab/... (mobile task list) and /overview/checklists/... (open processes).
  const { pathname } = useLocation()

  if (pathname === '/' && !isMobileOnly) {
    return <DashboardV2 />
  }

  return (
    <>
      { !isTablet && (
      <BrowserView>
        <NewOverview />
      </BrowserView>
      )}
      <TabletView>
        <NewOverview />
      </TabletView>
      {!isTablet && (
      <MobileOnlyView>
        <HomeMobile />
      </MobileOnlyView>
      )}
    </>
  )
}
